import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DropArea = styled.div<{
  isDragging?: boolean;
  hasFile?: boolean;
}>`
  border: 2px dashed #d0d5dd;
  border-radius: 12px;
  padding: 28px 24px;
  text-align: center;
  cursor: pointer;
  color: #667085;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  transition: all 0.2s ease;

  background: ${({ isDragging, hasFile }) =>
    isDragging
      ? '#eef4ff'
      : hasFile
      ? '#ecfdf3'
      : '#fafafa'};

  border-color: ${({ isDragging, hasFile }) =>
    isDragging
      ? '#3b82f6'
      : hasFile
      ? '#12b76a'
      : '#d0d5dd'};

  &:hover {
    border-color: ${({ hasFile }) =>
      hasFile ? '#12b76a' : '#3b82f6'};
    background: ${({ hasFile }) =>
      hasFile ? '#ecfdf3' : '#f4f8ff'};
  }

  span {
    font-size: 14px;
    font-weight: 500;
  }

  small {
    font-size: 12px;
    color: #98a2b3;
  }
`;

export const FilePreview = styled.div`
  margin-top: 6px;
  padding: 10px 14px;
  border-radius: 8px;
  background: white;
  border: 1px solid #e4e7ec;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;

  strong {
    font-size: 13px;
    color: #344054;
  }

  span {
    font-size: 12px;
    color: #98a2b3;
  }
`;


export const FileList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    font-size: 14px;
    color: #344054;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 4px;

  button {
    padding: 9px 16px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    transition: 0.15s ease;
  }

  /* botão limpar */
  button:first-child {
    background: #f2f4f7;
    color: #344054;
  }

  button:first-child:hover:not(:disabled) {
    background: #e4e7ec;
  }

  /* botão adicionar */
  button:last-child {
    background: #2563eb;
    color: #fff;
  }

  button:last-child:hover:not(:disabled) {
    background: #1d4ed8;
  }

  button:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const ProgressContainer = styled.div`
  width: 100%;
  height: 8px;
  background: #eee;
  border-radius: 4px;
  overflow: hidden;
`;

export const ProgressBar = styled.div<{ progress: number }>`
  width: ${({ progress }) => progress}%;
  height: 100%;
  background: #2563eb;
  transition: width 0.3s;

  animation: pulse 1s ease-in-out infinite;

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const FileName = styled.div`
  max-width: 340px;  
  overflow: hidden;
  text-overflow: ellipsis;
`;